import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Enrollment = loadable(() => import('./Enrollment'), {});
